import type { Profile } from '@/types/domain';

export function hasProfileInGameName(profile: Pick<Profile, 'inGameName'> | null | undefined): boolean {
  return Boolean(profile?.inGameName?.trim());
}

export function getProfileInGameName(profile: Pick<Profile, 'displayName' | 'inGameName'> | null | undefined): string {
  const inGameName = profile?.inGameName?.trim();

  if (inGameName) {
    return inGameName;
  }

  return profile?.displayName ?? 'Unknown Member';
}
